import React, { useState } from "react";
import { createPortal } from "react-dom";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import styles from "../../css/CreateOrder.module.css";
import CustomAlert from "../../helpers/CustomAlert";

const CancelShipmentModal = ({
  show,
  handleClose,
  defaultWaybill = "",
  onSuccess,
  refreshTable,
}) => {
  const courierKey = sessionStorage.getItem("courierServiceKey");
  const username = sessionStorage.getItem("username");

  const [reason, setReason] = useState("");
  const [waybill, setWaybill] = useState(defaultWaybill);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    const newErrors = {};
    if (!waybill.trim()) newErrors.waybill = "Waybill number is required";
    if (!reason.trim()) newErrors.reason = "Cancellation reason is required";

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
      return;
    }

    setError({});
    setLoading(true);

    const payload = {
      username,
      waybill: waybill.trim(),
      reason: reason.trim(),
    };

    const headers = {
      courierkey: courierKey,
      "Content-Type": "application/json",
    };

    try {
      const response = await axiosPostApi(
        apiList.CANCEL_SHIPMENT,
        payload,
        headers
      );
      if (response?.data?.meta?.status === "success") {
        CustomAlert({
          title: "Success",
          text: response?.data?.meta?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        setReason("");
        setWaybill("");
        if (typeof refreshTable === "function") {
          refreshTable();
        }
        handleClose();
        if (onSuccess) onSuccess();
      } else {
        CustomAlert({
          title: "Error",
          text: response?.data?.meta?.message || "Cancellation failed.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setReason("");
    setWaybill("");
    setError({});
    handleClose();
  };

  if (!show) return null;

  return createPortal(
    <div
      className={styles["overlay-style"]}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={styles["small-modal"]}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={handleClose}
          title="Close"
          className="absolute top-2 right-4 text-gray-500 hover:text-red-500 text-5xl leading-none focus:outline-none"
        >
          &times;
        </button>

        <div className={styles["header-style"]}>
          <h5 className="modal-title main-title"> Cancel Shipment</h5>
        </div>

        <form>
          <div className={styles["row-style"]}>
            <div>
              <label className={styles["label-style"]}>
                Waybill Number{" "}
                <span className={styles["required-asterisk"]}>*</span>
              </label>
              <input
                className={styles["input-style"]}
                value={waybill}
                onChange={(e) => setWaybill(e.target.value)}
                placeholder="Enter Waybill Number"
              />
              {error.waybill && (
                <div className={styles["error-style"]}>{error.waybill}</div>
              )}
            </div>

            <div>
              <label className={styles["label-style"]}>
                Cancellation Reason{" "}
                <span className={styles["required-asterisk"]}>*</span>
              </label>
              <textarea
                className={styles["input-style"]}
                style={{ height: "80px", resize: "vertical" }}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter reason..."
              />
              {error.reason && (
                <div className={styles["error-style"]}>{error.reason}</div>
              )}
            </div>
          </div>

          <div className={styles["cancel-shipment-button-container"]}>
            <button
              type="button"
              className={styles["btn-secondary"]}
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className={styles["btn-primary"]}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default CancelShipmentModal;
